<div class="hidden cursor-pointer lg:flex">
    @for (image of desktopImages(); track image) {
        @if ($last) {
            <div class="relative">
                <div class="absolute z-10 flex h-full w-full items-center justify-center bg-black-70">
                    <button
                        class="flex items-center gap-3 border-1 border-accent bg-white px-6 py-3 font-medium text-accent"
                        (click)="openVehicleGalleryOverlay(0)"
                    >
                        <i class="icon-image"></i>
                        <span>{{ images().length }} Bilder</span>
                    </button>
                </div>
                <ui-m000-c010-image
                    class="image-hover block h-full"
                    [classList]="'h-full w-full aspect-[767/202] md:aspect-[975/257] lg:aspect-[145/95] object-cover'"
                    [image]="{
                        image: image,
                        desktop: { width: 145, height: 95 },
                        tablet: { width: 145, height: 95 },
                        mobile: { width: 145, height: 95 },
                    }"
                    [priority]="isFirstView()"
                    alt=""
                />
            </div>
        } @else {
            <div (click)="openVehicleGalleryOverlay($index)">
                <ui-m000-c010-image
                    class="image-hover block h-full"
                    [classList]="'h-full w-full aspect-[145/95]'"
                    [image]="{
                        image: image,
                        desktop: { width: 145, height: 95 },
                        tablet: { width: 145, height: 95 },
                        mobile: { width: 145, height: 95 },
                    }"
                    [priority]="isFirstView()"
                    alt=""
                    cover
                />
            </div>
        }
    }
</div>
<div class="lg:hidden">
    <button
        class="flex items-center gap-3 border-1 border-accent bg-white px-6 py-3 font-bold text-accent"
        (click)="openVehicleGalleryOverlay(0)"
    >
        <i class="icon-image"></i>
        <span>{{ images().length }} Bilder</span>
    </button>
</div>
